import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "content visible-box" }
const _hoisted_2 = {
  class: "container-fluid",
  id: "itenary-div"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "col-sm-12",
    id: "top-margin"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "col-sm-12",
    id: "top-margin"
  })
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12 text-center" }, [
    /*#__PURE__*/_createElementVNode("div", {
      id: "breadcrums",
      style: {"color":"#34aade !important"}
    }, [
      /*#__PURE__*/_createElementVNode("h2", null, "Smart Planner")
    ]),
    /*#__PURE__*/_createElementVNode("div", { id: "tagline" }, [
      /*#__PURE__*/_createElementVNode("p", null, "Easy to find... Simple to use")
    ])
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { class: "row" }
const _hoisted_8 = {
  class: "col-sm-12 col-md-10 col-lg-9 col-xl-9",
  id: "sm-left-div",
  style: {"margin-top":"3% !important","padding-left":"50px"}
}
const _hoisted_9 = { class: "container" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "col-sm-12 col-md-10 col-lg-10 col-xl-10" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = {
  class: "col-sm-12 col-md-12 col-lg-12 col-xl-12",
  id: "card-img-itenary",
  style: {"padding":"0px !important"}
}
const _hoisted_14 = { class: "img-class" }
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  class: "col-sm-12 col-md-12 col-lg-12 col-xl-12",
  id: "itenary-info"
}
const _hoisted_17 = { class: "category-icons-row" }
const _hoisted_18 = ["src", "alt", "title"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "planner-save-label" }, "Save", -1)
const _hoisted_20 = ["for"]
const _hoisted_21 = ["id", "onClick"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-heart-o" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-heart" }, null, -1)
const _hoisted_24 = { id: "capt-line" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("b", null, "A:", -1)
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("b", null, "M:", -1)
const _hoisted_30 = {
  key: 0,
  class: "col-sm-12 col-md-12 col-lg-12 col-xl-12"
}
const _hoisted_31 = {
  class: "row",
  id: "detail-itenary"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12 col-md-12 col-lg-2 col-xl-2" }, null, -1)
const _hoisted_33 = {
  class: "col-sm-12 col-md-12 col-lg-8 col-xl-8",
  id: "card-img",
  style: {"padding":"0px !important"}
}
const _hoisted_34 = {
  id: "carouselExampleControls",
  class: "carousel slide",
  style: {"width":"100%"}
}
const _hoisted_35 = { class: "col padding-0" }
const _hoisted_36 = ["src"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12 col-md-12 col-lg-2 col-xl-2" }, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12 col-md-12 col-lg-2 col-xl-2" }, null, -1)
const _hoisted_39 = {
  class: "col-sm-12 col-md-12 col-lg-8 col-xl-8",
  id: "smart-search-text",
  style: {"border-radius":"0px 0px 10px 10px !important"}
}
const _hoisted_40 = ["src", "alt", "title"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_42 = { id: "capt-line" }
const _hoisted_43 = { style: {"color":"#bba756"} }
const _hoisted_44 = { id: "display-desc" }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("b", null, "A:", -1)
const _hoisted_47 = { key: 1 }
const _hoisted_48 = { key: 2 }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("b", null, "M:", -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { style: {"padding":"10px","width":"40px"} }, null, -1)
const _hoisted_51 = {
  key: 0,
  class: "col-lg-3 col-xl-3",
  id: "map-planner"
}
const _hoisted_52 = {
  key: 0,
  class: "map-error",
  style: {"padding":"20px","text-align":"center","background":"#f8f9fa","border":"1px solid #dee2e6","border-radius":"4px"}
}
const _hoisted_53 = /*#__PURE__*/_createElementVNode("p", { style: {"color":"#dc3545","margin-bottom":"10px"} }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Map Error")
], -1)
const _hoisted_54 = { style: {"font-size":"0.9em","color":"#6c757d"} }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"0.8em","color":"#6c757d","margin-top":"10px"} }, "Please check Google Maps API key configuration.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fis_header = _resolveComponent("fis-header")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_Marker = _resolveComponent("Marker")!
  const _component_CustomControl = _resolveComponent("CustomControl")!
  const _component_GoogleMap = _resolveComponent("GoogleMap")!
  const _component_fis_footer = _resolveComponent("fis-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, { style: {"overflow":"auto"} }, {
    default: _withCtx(() => [
      _createVNode(_component_fis_header),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.information, (cards, cardIndex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: cardIndex,
                    class: "row",
                    id: "small-itenary"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cards, (info, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "col-sm-6 col-md-6 col-lg-4 col-xl-4"
                      }, [
                        _createElementVNode("div", {
                          class: "row",
                          id: "itenary-card",
                          onClick: ($event: any) => (_ctx.moreInfo(cards, index))
                        }, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, [
                                  _createElementVNode("img", {
                                    src: _ctx.storageBaseUrl + '/' + info['images'][0]['image'],
                                    class: "planner-images",
                                    id: "img-class",
                                    alt: ""
                                  }, null, 8, _hoisted_15)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("h2", null, _toDisplayString(info['name']), 1),
                                _createElementVNode("div", _hoisted_17, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info['categories'], (category) => {
                                    return (_openBlock(), _createElementBlock("img", {
                                      key: category.id,
                                      src: _ctx.storageBaseUrl + '/' + category.black_path,
                                      alt: category.name,
                                      title: category.name
                                    }, null, 8, _hoisted_18))
                                  }), 128)),
                                  _hoisted_19,
                                  _createElementVNode("label", {
                                    for: 'itenary-heart-' + info.id,
                                    class: "custom-checkbox planner-heart",
                                    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                                  }, [
                                    _createElementVNode("input", {
                                      type: "checkbox",
                                      id: 'itenary-heart-' + info.id,
                                      onClick: _withModifiers(($event: any) => (_ctx.removeFavourites(info.id, index, cardIndex, $event)), ["stop"]),
                                      checked: ""
                                    }, null, 8, _hoisted_21),
                                    _hoisted_22,
                                    _hoisted_23
                                  ], 8, _hoisted_20)
                                ]),
                                _createElementVNode("p", _hoisted_24, _toDisplayString(info['intro']), 1),
                                (_ctx.formatPlannerAddress(info['address']))
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_25, [
                                      _hoisted_26,
                                      _createTextVNode(" " + _toDisplayString(_ctx.formatPlannerAddress(info['address'])), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (!_ctx.shouldHidePhone(info))
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      (info['formatted_phone'])
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_27, [
                                            _createElementVNode("b", null, _toDisplayString(_ctx.isAustralianMobile(info['formatted_phone']) ? 'M' : 'P') + ":", 1),
                                            _createTextVNode(" " + _toDisplayString(info['formatted_phone']), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (info['formatted_mobile'] && String(info['formatted_mobile']).length > 6)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_28, [
                                            _hoisted_29,
                                            _createTextVNode(_toDisplayString(info['formatted_mobile']), 1)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ], 8, _hoisted_10)
                      ]))
                    }), 128)),
                    _createVNode(_Transition, { name: "nested" }, {
                      default: _withCtx(() => [
                        (cards.show)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                              _createElementVNode("div", _hoisted_31, [
                                _hoisted_32,
                                _createElementVNode("div", _hoisted_33, [
                                  _createElementVNode("div", _hoisted_34, [
                                    _createVNode(_component_swiper, {
                                      slidesPerView: _ctx.slides,
                                      loop: _ctx.smartCardInfo['images'] && _ctx.smartCardInfo['images'].length > 3,
                                      navigation: true,
                                      class: _normalizeClass({ 'few-slides': _ctx.smartCardInfo['images'] && _ctx.smartCardInfo['images'].length <= 3 }),
                                      modules: _ctx.modules,
                                      id: "search-swipe"
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.smartCardInfo['images'], (image) => {
                                          return (_openBlock(), _createBlock(_component_swiper_slide, {
                                            key: image.id
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_35, [
                                                _createElementVNode("img", {
                                                  class: "planner-swiper-images",
                                                  src: _ctx.storageBaseUrl + '/' + image['image']
                                                }, null, 8, _hoisted_36)
                                              ])
                                            ]),
                                            _: 2
                                          }, 1024))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["slidesPerView", "loop", "class", "modules"])
                                  ])
                                ]),
                                _hoisted_37,
                                _hoisted_38,
                                _createElementVNode("div", _hoisted_39, [
                                  _createElementVNode("h2", null, _toDisplayString(_ctx.smartCardInfo['name']), 1),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.smartCardInfo['categories'], (icon) => {
                                    return (_openBlock(), _createElementBlock("img", {
                                      key: icon.id,
                                      src: _ctx.storageBaseUrl + '/' + icon.black_path,
                                      alt: icon.name,
                                      title: icon.name,
                                      style: {"margin-right":"5px"}
                                    }, null, 8, _hoisted_40))
                                  }), 128)),
                                  _hoisted_41,
                                  _createElementVNode("p", _hoisted_42, [
                                    _createElementVNode("em", _hoisted_43, _toDisplayString(_ctx.smartCardInfo['caption']), 1)
                                  ]),
                                  _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.smartCardInfo['description']), 1),
                                  (_ctx.formatPlannerAddress(_ctx.smartCardInfo['address']))
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_45, [
                                        _hoisted_46,
                                        _createTextVNode(" " + _toDisplayString(_ctx.formatPlannerAddress(_ctx.smartCardInfo['address'])), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.smartCardInfo['formatted_phone'])
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_47, [
                                        _createElementVNode("b", null, _toDisplayString(_ctx.isAustralianMobile(_ctx.smartCardInfo['formatted_phone']) ? 'M' : 'P') + ":", 1),
                                        _createTextVNode(" " + _toDisplayString(_ctx.smartCardInfo['formatted_phone']), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.smartCardInfo['formatted_mobile'] && String(_ctx.smartCardInfo['formatted_mobile']).length > 6)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_48, [
                                        _hoisted_49,
                                        _createTextVNode(_toDisplayString(_ctx.smartCardInfo['formatted_mobile']), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  _hoisted_50
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024)
                  ]))
                }), 128))
              ])
            ]),
            (_ctx.loaded)
              ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                  (_ctx.mapError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                        _hoisted_53,
                        _createElementVNode("p", _hoisted_54, _toDisplayString(_ctx.mapError), 1),
                        _hoisted_55
                      ]))
                    : (_openBlock(), _createBlock(_component_GoogleMap, {
                        key: _ctx.markers.length,
                        "api-key": "AIzaSyBdBeIG5lH6hcBakr4-_mI7t88XfkkVTr4",
                        center: _ctx.centre,
                        class: "map",
                        zoom: _ctx.mapZoom,
                        onError: _ctx.handleMapError
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.markers, (m, index) => {
                            return (_openBlock(), _createBlock(_component_Marker, {
                              key: `marker-${index}-${m.position.lat}-${m.position.lng}`,
                              options: { position: m.position, clickable: true, title: m.title || `Marker ${index + 1}` },
                              onClick: ($event: any) => (_ctx.zoomToMarker(m.position))
                            }, null, 8, ["options", "onClick"]))
                          }), 128)),
                          _createVNode(_component_CustomControl, {
                            position: "TOP_LEFT",
                            class: "ml-lg-n1",
                            style: {"padding":"10px","margin-left":"-1.5rem!important"}
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("button", {
                                class: "btn btn-primary",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.startMapsDirection()))
                              }, "Road Trip")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["center", "zoom", "onError"]))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode(_component_fis_footer)
      ])
    ]),
    _: 1
  }))
}